<template>
  <transition :name="transition">
  <div class="page-view-index">
    <div>
      <slide-bar :show="drawerShow" :pos="pos" :tran="tran" @change-show="changeDrawerShow" @on-hide="onHide" @on-show="onShow">
        <div class="userInfo" slot="drawer">
          <div class="box">
            <img class="avatar" src="../assets/img/enterprise/43_default_avatar.png" @click="login">
            <p v-if="user_phone" class="user_phone">{{ user_phone }}</p>
            <p v-if="user_phone" @click="isLogout" class="logout">
              <span>退出登录</span>
            </p>
            <p v-if="!user_phone" class="loginBtn" @click="login">
              <span>点击登录</span>
            </p>
          </div>
          <ul id="mainNav">
           <li @click="jumpPage('/myOrder')">
              <i class="icon_nav_order"></i>我的订单
            </li>
            <li @click="jumpPage('/collectLine')">
              <i class="icon_nav_collect"></i>我的收藏
            </li>
            <li @click="jumpPage('/feedbackEnt')">
              <i class="icon_nav_custom"></i>线路反馈
            </li>
            <!-- <li @click="jumpPage('/customLine')">
              <i class="icon_nav_custom"></i>定制开通
            </li>-->
            <li @click="jumpPage('/myMessage')">
              <i class="icon_nav_message"></i>
              <span class="new_message_tips">
                我的消息
                <b v-if="new_message"></b>
              </span>
            </li>
           <!-- <li @click="jumpPage('/userInfo')">
              <i class="icon_nav_user"></i>
              个人信息
            </li> -->
             <li @click="jumpPage('/feedback')">
              <i class="icon_nav_help"></i>意见反馈
            </li>
            <li @click="jumpPage('/checkedRecord')">
              <i class="icon_nav_checked_record"></i>验票记录
            </li>
            <li @click.stop="linkVersion">
              <i class="icon_back_version"></i>返回旧版
            </li>
          </ul>
          <footer class="slider_bottom" style="min-height: 50px;">
            <div class="serive_phone">
              <span v-if="sever_phone">客服电话：</span>
              <a @click="markClick" :href="'tel:'+ sever_phone ">{{sever_phone}}</a>
            </div>
            <span class="select_city" @click="jumpPage('/selectCity')">
              <i class="icon_location"></i>
              <span>{{ current_city || '无定位' }}</span>
            </span>
          </footer>
        </div>
      </slide-bar>
    </div>
    <div class="select_city_dialog" v-if="(show_select_dialog == 2 || (!cacheCity && show_select_dialog == 1) || !current_city)&&is_loaded_location">
      <div class="dialog_content">
        <p v-if="show_select_dialog == 2">哇呜，当前城市未开通班车哦</p>
        <p v-else>哇呜，暂时定位不到当前城市</p>
        <a v-if="show_select_dialog == 2" @click="jumpPage('/selectCity')" class="redBtn">切换到其他城市</a>
        <a v-else @click="jumpPage('/selectCity')" class="redBtn">手动选择城市</a>
      </div>
    </div>
    <div class="container" style="padding-top:0; position: relative;">
      <div class="scene_nav_box">
        <div class="usercenter_btn" @click.stop="changeDrawerShow(true)">
          <span class="icon-user-center-btn opt_icon_user"></span>
          <b v-if="new_message" class="new_message"></b>
        </div>
        <div class="view-city" @click.stop="jumpPage('/selectCity')">
          <span class="text">{{ current_city || '无定位' }}</span>
          <span class="icon opt_icon_arrow"></span>
        </div>
      </div>
      <notice v-if="view_type === 'address'" position="1" @noticed="showNotice"></notice>
      <div class="view-commuter">
        <commute-address v-if="view_type === 'address'" :show_notice="is_show_notice"></commute-address>
        <commute-code v-if="view_type === 'code'"></commute-code>
      </div>
      <template v-if="last_feedback_message">
        <div class="view-feedback-message" :class="show_last_feedback_message ? 'active' : ''">
          <div class="feedback-message" @click.stop="toFeedbackDetail">
            <div class="message-tips">
              <span class="message-tips-title">{{last_feedback_title}}</span>
              <span>{{last_feedback_message}}</span>
            </div>
            <div class="btn-message-control">查看</div>
          </div>
        </div>
      </template>
    </div>
    <confirm
      :is_show="show_logout_dialog"
      title="确定要退出登录吗？"
      :is_logout="true"
      :phone="user_real_phone"
      leftContent="再想想"
      rightContent="确认"
      @confirm="logout"
      @cancel="show_logout_dialog=!show_logout_dialog" >
    </confirm>
    <confirm
      :is_show="(!!location_dialog_type && is_loaded_location)"
      title=""
      :is_logout="false"
      :phone="true"
      leftContent="否"
      rightContent="是"
      @confirm="jumpPage('/selectCity')"
      @cancel="setCacheCity" >
      <div class="confirm_content_text">您的定位功能未打开，目前所定位城市为{{cacheCity}}，是否手动定位城市？</div>
    </confirm>
  </div>
  </transition>
</template>

<script>
import SliderBar from '../components/SliderBar'
import Notice from '../components/Notice'
import Confirm from '../components/Confirm'
import CommuteAddress from '../pages/CommuteAddress'
import CommuteCode from '../pages/CommuteCode'
import '../assets/scss/sprites/icons_optimize.scss'
import '../assets/scss/sprites/nav_icons.scss'
import { showTips, postCnzzData, cutstr } from '../assets/js/util'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Index',
  components: {
    notice: Notice,
    slideBar: SliderBar,
    Confirm: Confirm,
    commuteAddress: CommuteAddress,
    CommuteCode: CommuteCode
  },
  data () {
    return {
      view_type: 'address', // 显示类型
      show_logout_dialog: false,
      show_location_dialog: false,
      is_true: false,
      user_real_phone: null,
      pos: 'left',
      tran: 'overlay',
      drawerShow: false,
      show_last_feedback_message: false, // 最后的反馈信息
      last_feedback_message: '', // 最后的反馈信息
      last_feedback_title: '', // 最后的反馈信息
      last_feedback_id: '', // 最后的反馈信息
      last_feedback_message_id: '', // 最后的反馈信息
      cacheCity: window.localStorage.getItem('location_city_cache') || '',
      is_show_notice: false, // 是否显示通知
      message_timer: '' // 定时器
    }
  },
  props: {
    title: {},
    transition: {}
  },
  computed: {
    ...mapGetters([
      'is_login',
      'user_phone',
      'enterprise_id',
      'innerHeight',
      'server_phone',
      'new_message',
      'current_city',
      'show_select_dialog',
      'sever_phone',
      'is_loaded_location',
      'user_info',
      'current_pos'
    ]),
    current_title () {
      return this.$route.meta.title
    },
    current_router () {
      return this.$route.name
    },
    location_dialog_type: {
      get: function () {
        return (this.show_select_dialog === 1 && this.show_location_dialog && this.cacheCity)
      },
      set: function (val) {
        this.show_location_dialog = false
      }
    }
  },
  watch: {
    '$route' (to, _from) {
      var _self = this
      if (to.query.type && (to.query.type === 'code' || to.query.type === 'address')) {
        _self.view_type = to.query.type || 'address'
      }
      if (_from && _from.name === 'myMessage') {
        if (_self.is_login) {
          _self.getMessage()
        }
      }
    },
    is_login (val) {
      if (val) {
        this.getMessage()
        this.getLastMessage()
      }
    }
  },
  methods: {
    ...mapActions([
      'userLogout',
      'setUserInfo',
      'setCurrentCity',
      'getMessage',
      'setLoadedLocation',
      'getLastFeedbackMessage'
    ]),
    linkVersion () {
      reportEvent('返回旧版')
      // 跳转新版本
      var _self = this
      var _id = ''
      if (_self.user_info && _self.user_info.id) {
        _id = _self.user_info.id + ''
      } else {
        _id = '未登录'
      }
      postCnzzData('15.2.1 首页跳转旧版入口', _id, '点击')
      var url = '/commuter_old/dist/e/43/'
      if (_self.current_pos && _self.current_pos.lat) {
        url = url + '?lat=' + _self.current_pos.lat + '&lng=' + _self.current_pos.lng
      }
      if (_self.current_pos && _self.current_pos.lat && _self.current_city) {
        url = url + '&city_name=' + _self.current_city
      }
      window.location.href = url
    },
    setCacheCity () {
      var city_name = this.cacheCity
      this.location_dialog_type = false
      this.setCurrentCity(city_name)
    },
    markClick () {
      postCnzzData('5.4 点击客服电话')
    },
    showNotice (val) {
      // 显示触发通知
      var self = this
      self.is_show_notice = val || false
    },
    jumpPage (path) {
      if (path === '/selectCity') {
        reportEvent('切换城市')
      }
      if (path === '/collectLine') {
        reportEvent('首页我的收藏')
      }
      var query = {}
      // 对于反馈进行特殊处理
      if (path === '/feedback') {
        reportEvent('意见反馈')
        query = {
          from: 'index'
        }
      }
      if (path === '/feedbackEnt') {
        reportEvent('线路反馈')
        query = {
          from_type: 'home'
        }
      }
      if (this.enterprise_id) {
        path = '/e/' + this.enterprise_id + path
      }
      this.$router.push({
        path: path,
        query: query
      })
    },
    login () {
      reportEvent('跳转登录')
      var _self = this
      if (!_self.is_login) {
        var path = '/login'
        if (_self.enterprise_id) {
          path = '/e/' + _self.enterprise_id + path
        }
        _self.$router.push({
          path: path,
          query: {
            from: _self.$route.fullPath
          }
        })
      }
    },
    logout () {
      const _self = this
      const _result = this.userLogout()
      _result.then(function (_res) {
        showTips('登出成功')
        _self.show_logout_dialog = false
        // 登出成功 清除用户信息
        _self.setUserInfo({})
      }, function (_res) {
        // 登出失败
        showTips('登出失败')
      })
      return false
    },
    isLogout () {
      this.show_logout_dialog = true
    },
    onHide () {
      // console.log('hide')
    },
    changeDrawerShow (state) {
      this.drawerShow = state
    },
    onShow () {
      // console.log('show')
    },
    getLastMessage () {
      var _self = this
      if (_self.is_login) {
        _self.getLastFeedbackMessage().then(function (res) {
          var _text = '反馈回复：'
          if (res && res.data && res.data.reply_content) {
            if (res.data.rank === '0') {
              _text = '供应商客服回复：'
            } else if (res.data.rank === '1') {
              _text = '供应商项目经理回复：'
            } else if (res.data.rank === '1') {
              _text = '企业回复：'
            }
            _self.last_feedback_title = _text
            _self.last_feedback_message = cutstr(res.data.reply_content || '', 30)
            setTimeout(function () {
              _self.show_last_feedback_message = true
            }, 600)
            _self.message_timer = setTimeout(function () {
              _self.message_timer = ''
              _self.show_last_feedback_message = false
            }, 5000)
            _self.last_feedback_id = res.data.suggest_id || ''
            _self.last_feedback_message_id = res.data.id || ''
          }
        })
      }
    },
    toFeedbackDetail () {
      var _self = this
      _self.last_feedback_message = ''
      _self.$router.push({
        path: '/e/' + _self.enterprise_id + '/feedbackDetail/' + _self.last_feedback_message_id,
        query: {
          suggest_id: _self.last_feedback_id
        }
      })
    }
  },
  created () {
    var _self = this
    if (_self.$route.query.type) {
      _self.view_type = _self.$route.query.type
    }
    _self.show_location_dialog = true
    // 启动定时器，切换定位状态
    if (!_self.is_loaded_location) {
      setTimeout(function () {
        _self.setLoadedLocation(true)
      }, 6000)
    }
    if (_self.is_login) {
      _self.getMessage()
      _self.getLastMessage()
    }
    // 防注入
    setTimeout(function () {
      try {
        var _remove_list = []
        for (var i = 0, len = document.body.children.length; i < len; i++) {
          var _ele = document.body.children[i]
          if (_ele) {
            if (!(_ele.tagName === 'DIV' && _ele.id === 'app')) {
              if (_ele.tagName !== 'SCRIPT') {
                _remove_list.push(_ele)
              }
            }
          }
        }
        for (var j = 0, j_len = _remove_list.length; j < j_len; j++) {
          if (_remove_list[j]) {
            _remove_list[j].parentNode.removeChild(_remove_list[j])
          }
        }
        // }
      } catch (e) {
        console.log(e)
      }
    }, 2000)
  },
  beforeDestroy () {
    var _self = this
    if (_self.message_timer) {
      clearTimeout(_self.message_timer)
      _self.message_timer = ''
    }
  },
  mounted () {
    reportEvent('华为首页')
  }
}
</script>

<style lang="scss">
  @import '../assets/scss/base.scss';
  .view-commuter {
    position: relative;
    padding: 0;
    margin: 0;
  }
  .cancel_dialog {
    .confirm_content_text{
      padding-bottom: pxToRem(58px);
      padding-left: pxToRem(20px);
      padding-right: pxToRem(20px);
      font-size: 14px;
      text-align: center;
      color: #222222;
    }
  }
  .select_city_dialog {
    position: fixed;
    top: 0;
    bottom: 0;
    z-index: 101;
    width: 100%;
    background: rgba(0,0,0,0.7);
    .dialog_content {
      margin: auto;
      width: 84%;
      text-align: center;
      background: #fff;
      position: absolute;
      top: 50%;
      left: 8%;
      margin-top: -65px;
      border-radius: 5px;
      p {
        font-size: 16px;
        color: #3f3f4d;
        padding: 33px 10px 30px 10px;
      }
      .redBtn {
        width: 94%;
        display: block;
        text-align: center;
        margin: 0 auto;
        height: 44px;
        line-height: 44px;
        font-size: 14px;
        background: $opt-color;
        border-radius: 5px;
        color: #fff;
        margin-bottom: 10px;
      }
    }
  }
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    visibility: hidden;
    opacity: 0;
    transition: opacity ease-in-out 0.38s, visibility ease-in-out 0.38s;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 999;
  }
  .slider_bottom {
    position: absolute;
    padding: 0 20px;
    bottom: 0px;
    width: 100%;
    background-color: #fff;
    .serive_phone {
      text-align: right;
      padding: 15px 0;
      border-top: 1px solid #dcdcdc;
      // position: absolute;
      // bottom: pxToRem(80px);
      line-height: 20px;
      font-size: 12px;
      padding-left: pxToRem(74px);
      a {
        color: $blue;
      }
    }
    .select_city {
      position: absolute;
      top: 50%;
      font-size: 14px;
      left: 20px;
      color: #222222;
      -webkit-transform: translate(0, -50%);
      transform: translate(0, -50%);
      -webkit-transform-style: preserve-3d;
      -webkit-backface-visibility: hidden;
      line-height: normal;
      i {
        display: inline-block;
        vertical-align: middle;
      }
      span{
        display: inline-block;
        vertical-align: middle;
        color: #222222;
        font-size: 14px;
      }
    }
  }
  .drawer {
    position: fixed;
    background: #fff;
    height: 100%;
    top: 0;
    bottom: 0;
    z-index: 1000;
    overflow: hidden;
    pointer-events: none;
    visibility: hidden;
    transition: transform ease-in-out 0.38s, visibility 0.38s;
    will-change: none;
    .new_message_tips {
      position: relative;
      b {
        position: absolute;
        right: -10px;
        width: 6px;
        height: 6px;
        background: red;
        top: -2px;
        border-radius: 25px;
      }
    }
    .userInfo {
      font-size: 16px;
      padding-top: 1.5rem;
      max-height: 100%;
      -webkit-box-sizing: border-box;
      overflow: auto;
      .box {
        position: relative;
        width: pxToRem(534px);
        margin: 0 18px;
        padding: 4px 0 15px;
        box-sizing: border-box;
        border-bottom: 1px solid $gray-light;
      }
      .avatar {
        width: 55px;
        height: 55px;
        display: block;
        margin: 0 auto;
      }
      .user_phone {
        text-align: center;
        padding-top: 10px;
        color: $black-light;
      }
      .logout, .loginBtn {
        text-align: center;
        padding: 8px;
        font-size: 14px;
      }
    }
  }
  .active {
    visibility: visible;
    opacity: 1;
  }
  #mainNav {
    font-size: 13px;
    padding-top: pxToRem(30px);
    margin-bottom: 50px;
    li {
      position: relative;
      display: block;
      height: pxToRem(106px);
      line-height: pxToRem(110px);
      color: $black-light;
      padding-left: pxToRem(126px);
      box-sizing: border-box;
      &:active {
        background: #f2f2f2;
      }
      i {
        @include center_vertical;
        left: pxToRem(64px);
        top: -1px;
      }
      a {
        display: block;
        height: pxToRem(106px);
        line-height: pxToRem(106px);
        color: $black-light;
      }
    }
    .active {
      background-color: #f2f2f2;
    }
  }
  .scene_nav_box {
    position: relative;
    background: #eceff4;
    box-shadow: 0 0 0.13333rem 0 rgba(120, 135, 160, 0.2);
    height: 34px;
    overflow: hidden;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    z-index: 1;
    .view-city {
      position: absolute;
      right: 14px;
      top: 0;
      padding: 8px 0 8px 10px;
      display: inline-block;
      text-align: right;
      .text {
        display: inline-block;
        vertical-align: top;
        font-size: 12px;
        color: #333;
        line-height: 18px;
      }
      .icon {
        display: inline-block;
        vertical-align: top;
        margin-top: 4px;
      }
    }
  }
  .usercenter_btn{
    position: absolute;
    left: 0;
    top: 0;
    width: 46px;
    background: transparent;
    z-index: 1;
    display: block;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    -webkit-touch-callout: none;
    i , .icon-user-center-btn{
      margin: 8px 14px;
      display: inline-block;
      vertical-align: top;
    }
    .new_message {
      position: absolute;
      right: 6px;
      width: 6px;
      height: 6px;
      background: red;
      top: 5px;
      border-radius: 25px;
    }
  }
  .scene_nav {
    padding-left: 55px;
    max-width: 600px;
    height: 60px;
    padding-top: 16px;
    white-space: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    overflow-y: hidden;
    ::-webkit-scrollbar {
      display:none
    }
    a {
      position: relative;
      display: inline-block;
      width: auto;
      height: 27px;
      text-align: center;
      line-height: 27px;
      font-size: 14px;
      padding: 0 pxToRem(20px);
      i {
        width: auto;
        line-height: 27px;
        font-style: normal;
        display: inline-block;
        margin: 0 auto;
        word-break: break-all;
        vertical-align: top;
        overflow: hidden;
        height: 100%;
        padding: 0 pxToRem(24px);
      }
      .current {
        background: $opt-color;
        border-radius: 25px;
        color: #fff;
        font-size: 16px;
      }
    }
  }
  ::-webkit-scrollbar{
    display:none;
  }
  .page-view-index {
    .view-feedback-message {
      z-index: 10;
      position: absolute;
      width: 100%;
      max-width: 100%;
      overflow: hidden;
      bottom: 0;
      left: 0;
      padding: 8px 16px 20px 16px;
      margin: 0;
      background-color: transparent;
      -webkit-transform: translate(0, 100%);
      -moz-transform: translate(0, 100%);
      -ms-transform: translate(0, 100%);
      -o-transform: translate(0, 100%);
      transform: translate(0, 100%);
      transition: transform 1s;
    }
    .view-feedback-message.active {
      -webkit-transform: translate(0, 0);
      -moz-transform: translate(0, 0);
      -ms-transform: translate(0, 0);
      -o-transform: translate(0, 0);
      transform: translate(0, 0);
    }
    .feedback-message {
      position: relative;
      padding: 8px 75px 8px 8px;
      margin: 0;
      background-color: #fff;
      line-height: 18px;
      font-size: 14px;
      color: #666;
      box-shadow: 0 0 6px 6px rgba(120, 135, 160, 0.1);
      -webkit-border-radius: 6px;
      -moz-border-radius: 6px;
      border-radius: 6px;
    }
    .message-tips-title {
      color: #333;
    }
    .btn-message-control {
      position: absolute;
      top: 50%;
      right: 8px;
      padding: 3px 13px;
      margin: -12px 0 0 0;
      font-size: 14px;
      background-color: #039be5;
      -webkit-border-radius: 4px;
      -moz-border-radius: 4px;
      border-radius: 4px;
      color: #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// Index.vue?4a414506